import {
  CAMPAIGN_LIST_LOADING,
  CAMPAIGN_LIST_SUCCESS,
  CAMPAIGN_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { campaignListUrl } from "api/apiUrls";

export const campaignListAction = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: CAMPAIGN_LIST_LOADING, payload: true });
    const response = await listItemsService(`${campaignListUrl}`);

    dispatch({ type: CAMPAIGN_LIST_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: CAMPAIGN_LIST_FAILURE, payload: err });
  } finally {
    dispatch({ type: CAMPAIGN_LIST_LOADING, payload: false });
  }
};
